import { useCountdownTimer } from '~/hooks'
import { ClockIcon } from '@heroicons/react/24/outline'
import type { ReactNode } from 'react'
import { getUkTodayString } from '~/utils'

const LabelOutput = ({ children }: { children: ReactNode }) => (
  <p className="mb-0 text-sm">
    <ClockIcon className="inline size-6 text-teal-green" />
    {children}
    &nbsp;for&nbsp;
    <span className="font-semibold">same day delivery</span>
  </p>
)

interface Props {
  deliveryDate?: string | null
}

const ProductDeliveryTimer = ({ deliveryDate }: Props) => {
  const result = useCountdownTimer({
    cutoffHour: 12,
    cutoffMinute: 0,
  })

  const ukToday = getUkTodayString()
  const showTimer = !!deliveryDate && deliveryDate === ukToday

  if (!showTimer || !result) return null

  const { isBeforeCutoff, timeLeft } = result

  if (!isBeforeCutoff) {
    return (
      <LabelOutput>
        &nbsp;&nbsp;Order before&nbsp;
        <span className="font-semibold text-teal-green">12pm</span>
      </LabelOutput>
    )
  }

  const { hours, minutes } = timeLeft

  return (
    <LabelOutput>
      &nbsp;&nbsp;Order within&nbsp;
      <span className="font-semibold text-teal-green">
        {hours}hrs {minutes}mins
      </span>
    </LabelOutput>
  )
}

export default ProductDeliveryTimer
